import AppleLogin from "react-apple-login";
import { useRecoilValue } from "recoil";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import { userSimpleAtom } from "../../recoil/userSimpleAtom";
import { useRef, useState } from "react";
import { isDev } from "../../config";
import useLoginV6Mutation from "../../hooks/useLoginV6Mutation";
import { decodeJWT } from "../../utils/jwtUtils";
import useAppleJs from "../../hooks/useAppleJs";
import useMixpanelMKT from "../../hooks/useMixpanelMKT";

export default function AppleLoginButtonV6({
  render,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
}) {
  const user = useRecoilValue(userSimpleAtom);
  const [isLoading, setIsLoading] = useState(false);
  const { loginAsync } = useLoginV6Mutation("apple");
  const appleReady = useAppleJs();

  const trackLoginButtonClick = useMixpanelMKT({
    eventName: "로그인 버튼 클릭",
    params: { method: "apple" },
    version: "v6",
  });

  const focusListenerRef = useRef<((this: Window, ev: FocusEvent) => any) | null>(
    null
  );
  const callbackFiredRef = useRef(false);

  const clearFocusListener = () => {
    if (focusListenerRef.current) {
      window.removeEventListener("focus", focusListenerRef.current);
      focusListenerRef.current = null;
    }
  };

  const apple_cliendId = isDev
    ? "dev.orwellhealth.distancing.login"
    : "com.orwellhealth.distancing.login";

  const apple_v6_redirectUrl = isDev
    ? "https://dev-www.distancing.im/v6/oauth/apple"
    : `${window.location.origin}/v6/oauth/apple`;

  if (!appleReady) {
    return (
      <LoginButtonTemplatePromotion
        loginType="apple"
        action={() => {}}
        isLoggedIn={!!user?.accessToken}
        isLoading={false}
      />
    );
  }

  return (
    <AppleLogin
      clientId={apple_cliendId}
      redirectURI={apple_v6_redirectUrl}
      responseType="code id_token"
      responseMode="form_post"
      scope="email"
      usePopup
      callback={(response: any) => {
        try {
          callbackFiredRef.current = true;
          clearFocusListener();
          const idToken = response?.authorization?.id_token;
          if (idToken) {
            const decodedToken = decodeJWT(idToken);
            const email = decodedToken?.email || undefined;
            loginAsync({ idToken, email })
              .catch(() => {})
              .finally(() => {
                setIsLoading(false);
                clearFocusListener();
              });
          } else {
            setIsLoading(false);
          }
        } catch (e) {
          setIsLoading(false);
        }
      }}
      render={
        render
          ? render
          : (props) => (
              <LoginButtonTemplatePromotion
                loginType="apple"
                action={() => {
                  trackLoginButtonClick();
                  setIsLoading(true);
                  callbackFiredRef.current = false;
                  const onFocus = () => {
                    setTimeout(() => {
                      if (!callbackFiredRef.current) {
                        setIsLoading(false);
                        clearFocusListener();
                      }
                    }, 300);
                  };
                  focusListenerRef.current = onFocus;
                  window.addEventListener("focus", onFocus);
                  props.onClick();
                }}
                isLoggedIn={!!user?.accessToken}
                isLoading={isLoading}
              />
            )
      }
    />
  );
}
